var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnouncements(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4720_17075)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8505 4.22445L17.212 0.585942C16.834 0.207915 16.3331 0 15.7992 0H4.5623C3.45657 0 2.56348 0.897815 2.56348 1.99882V22.0012C2.56348 23.1022 3.46129 24 4.5623 24H19.4377C20.5387 24 21.4365 23.1022 21.4365 22.0012V5.63733C21.4365 5.10337 21.2286 4.60248 20.8505 4.22445ZM17.0183 2.27761L19.1589 4.41819H17.0183V2.27761ZM20.1039 22.0059C20.1039 22.3745 19.8062 22.6722 19.4377 22.6722H4.5623C4.19372 22.6722 3.89602 22.3745 3.89602 22.0059V1.99882C3.89602 1.63024 4.19372 1.33255 4.5623 1.33255H15.6857V5.08447C15.6857 5.45304 15.9834 5.75074 16.352 5.75074H20.1039V22.0059Z",
    fill: "#545B5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.80721 19.5488H5.74342C5.37485 19.5488 5.07715 19.8465 5.07715 20.2151C5.07715 20.5837 5.37485 20.8814 5.74342 20.8814H9.80721C10.1758 20.8814 10.4735 20.5837 10.4735 20.2151C10.4782 19.8465 10.1758 19.5488 9.80721 19.5488Z",
    fill: "#545B5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8759 15.4434H5.7483C5.37973 15.4434 5.08203 15.7411 5.08203 16.1096C5.08203 16.4782 5.37973 16.7759 5.7483 16.7759H13.8759C14.2445 16.7759 14.5422 16.4782 14.5422 16.1096C14.5422 15.7411 14.2445 15.4434 13.8759 15.4434Z",
    fill: "#545B5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2516 11.3359H5.7483C5.37973 11.3359 5.08203 11.6336 5.08203 12.0022C5.08203 12.3708 5.37973 12.6685 5.7483 12.6685H18.2563C18.6249 12.6685 18.9226 12.3708 18.9226 12.0022C18.9178 11.6336 18.6201 11.3359 18.2516 11.3359Z",
    fill: "#545B5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2563 7.23047H5.7483C5.37973 7.23047 5.08203 7.52817 5.08203 7.89674C5.08203 8.26532 5.37973 8.56301 5.7483 8.56301H18.2563C18.6249 8.56301 18.9226 8.26532 18.9226 7.89674C18.9226 7.52817 18.6249 7.23047 18.2563 7.23047Z",
    fill: "#545B5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4595 3.12305H5.7483C5.37973 3.12305 5.08203 3.42074 5.08203 3.78932C5.08203 4.1579 5.37973 4.45559 5.7483 4.45559H10.4595C10.828 4.45559 11.1257 4.1579 11.1257 3.78932C11.1257 3.42074 10.828 3.12305 10.4595 3.12305Z",
    fill: "#545B5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3316 16.0617C18.067 15.7971 17.6464 15.7971 17.3865 16.0617L13.8236 19.6247L12.1839 17.985C11.924 17.7251 11.5035 17.7251 11.2389 17.985C10.979 18.2449 10.979 18.6654 11.2389 18.93L13.3511 21.0423C13.4834 21.1746 13.6535 21.236 13.8236 21.236C13.9937 21.236 14.1638 21.1698 14.2962 21.0423L18.3316 17.0068C18.5915 16.7469 18.5915 16.3264 18.3316 16.0617Z",
    fill: "#545B5B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4720_17075"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncements);
export default __webpack_public_path__ + "static/media/announcements.476261dd1bb0d892967c93e4b62b827d.svg";
export { ForwardRef as ReactComponent };